"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var regions_unavailable_1 = require("@launchedla/hb-shared/dist/regions-unavailable");
var react_1 = __importStar(require("react"));
var react_query_1 = require("react-query");
var react_slick_1 = __importDefault(require("react-slick"));
var fetch_products_by_collection_name_1 = __importDefault(require("../../utils/fetch-products-by-collection-name"));
var fetch_user_geolocation_1 = require("../../utils/fetch-user-geolocation");
var upsell_card_1 = __importDefault(require("./upsell-card"));
var buildVariantConfig = function (cmsVariantConfigs) {
    var e_1, _a;
    var configs = cmsVariantConfigs === null || cmsVariantConfigs === void 0 ? void 0 : cmsVariantConfigs.split(',');
    if (!configs)
        return;
    var variantConfigs = [];
    try {
        for (var configs_1 = __values(configs), configs_1_1 = configs_1.next(); !configs_1_1.done; configs_1_1 = configs_1.next()) {
            var config = configs_1_1.value;
            var _b = __read(config.split(':').map(function (substring) { return substring.trim(); }), 2), variantId = _b[0], nameOverride = _b[1];
            variantConfigs.push({ variantId: Number(variantId), nameOverride: nameOverride });
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (configs_1_1 && !configs_1_1.done && (_a = configs_1.return)) _a.call(configs_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
    return variantConfigs;
};
/**
 * @param userCountryCode e.g. "US" or "CA"
 */
var tagAndCountryCodeRestrictProduct = function (unavailableRegions, userCountryCode) {
    var e_2, _a;
    try {
        for (var unavailableRegions_1 = __values(unavailableRegions), unavailableRegions_1_1 = unavailableRegions_1.next(); !unavailableRegions_1_1.done; unavailableRegions_1_1 = unavailableRegions_1.next()) {
            var region = unavailableRegions_1_1.value;
            if (userCountryCode === region.countryCode && !region.provinceCode)
                return true;
            // can add a check for an unavailable provinceCode here when needed
        }
    }
    catch (e_2_1) { e_2 = { error: e_2_1 }; }
    finally {
        try {
            if (unavailableRegions_1_1 && !unavailableRegions_1_1.done && (_a = unavailableRegions_1.return)) _a.call(unavailableRegions_1);
        }
        finally { if (e_2) throw e_2.error; }
    }
    return false;
};
var UpsellsArea = function (_a) {
    var title = _a.title, cartItems = _a.cartItems, setIsAddingProduct = _a.setIsAddingProduct, cartSettings = _a.cartSettings;
    // Figure out which bundle to show upsells for.
    var bundleConfig = (0, react_1.useMemo)(function () {
        // show diaper bundle cart upsells if we have a diaper bundle with less than 5 items
        var diaperBundle = cartItems.find(function (item) { return item.item.handle === 'diaper-bundle'; });
        if (diaperBundle) {
            var numDiscountItemsAlreadyInBundle = diaperBundle.children
                ? diaperBundle.children.reduce(function (acc, childItem) {
                    return childItem.title.includes('(Bundle) (Discount)') ? acc + childItem.quantity : acc;
                }, 0)
                : 0;
            if (cartSettings.enableCartUpsells && numDiscountItemsAlreadyInBundle < 5)
                return { bundle: diaperBundle, bundleType: 'diaper-bundle' };
        }
        // show fundamentals bundle cart upsells if we have a fundamentals bundle
        var fundamentalsBundle = cartItems.find(function (item) { return item.item.handle === 'fundamentals-bundle'; });
        if (fundamentalsBundle && cartSettings.enableCartUpsellsFundamentals)
            return { bundle: fundamentalsBundle, bundleType: 'fundamentals-bundle' };
        // show vitamins bundle cart upsells if we have a vitamins bundle
        var vitaminsBundle = cartItems.find(function (item) { return item.item.handle === 'vitamin-bundle'; });
        if (vitaminsBundle && cartSettings.enableCartUpsellsVitamins)
            return { bundle: vitaminsBundle, bundleType: 'vitamin-bundle' };
        // show a-la-carte cart upsells otherwise, even if there are no items in the cart yet
        if (cartSettings.enableCartUpsellsALaCarte)
            return { bundle: undefined, bundleType: 'a-la-carte' };
    }, [cartItems, cartSettings.enableCartUpsells, cartSettings.enableCartUpsellsALaCarte, cartSettings.enableCartUpsellsFundamentals, cartSettings.enableCartUpsellsVitamins]);
    var cartUpsellsQuery = (0, react_query_1.useQuery)('cartUpsellsCollection', function () { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
        return [2 /*return*/, (0, fetch_products_by_collection_name_1.default)('cart-upsells')];
    }); }); }, { enabled: !!bundleConfig });
    var userGeolocationQuery = (0, react_query_1.useQuery)([fetch_user_geolocation_1.getOrFetchAndUpdateCountryCodeByIpCookieUseQueryKey], fetch_user_geolocation_1.getOrFetchAndUpdateCountryCodeByIpCookie);
    // Build the variant ids and name overrides of the variants to display for this bundle type from the CMS.
    var upsellVariantConfigs = (0, react_1.useMemo)(function () {
        if (!(bundleConfig === null || bundleConfig === void 0 ? void 0 : bundleConfig.bundleType))
            return [];
        if (bundleConfig.bundleType === 'diaper-bundle') {
            return buildVariantConfig(cartSettings.cartUpsellVariantIds);
        }
        if (bundleConfig.bundleType === 'fundamentals-bundle') {
            return buildVariantConfig(cartSettings.cartUpsellVariantIdsFundamentals);
        }
        if (bundleConfig.bundleType === 'vitamin-bundle') {
            return buildVariantConfig(cartSettings.cartUpsellVariantIdsVitamins);
        }
        return buildVariantConfig(cartSettings.cartUpsellVariantIdsALaCarte);
    }, [
        bundleConfig === null || bundleConfig === void 0 ? void 0 : bundleConfig.bundleType,
        cartSettings.cartUpsellVariantIds,
        cartSettings.cartUpsellVariantIdsALaCarte,
        cartSettings.cartUpsellVariantIdsFundamentals,
        cartSettings.cartUpsellVariantIdsVitamins,
    ]);
    // Build a flat list of the products, variants, and name overrides to try to upsell, in order of configured variants in the CMS.
    var upsellVariantGroups = (0, react_1.useMemo)(function () {
        var e_3, _a;
        if (!cartUpsellsQuery.data || !userGeolocationQuery.data || !upsellVariantConfigs || !bundleConfig)
            return [];
        var variantGroups = [];
        var _loop_1 = function (config) {
            // create a grouped product, variant, and name override
            var variantGroup = (function () {
                var e_4, _a, e_5, _b;
                try {
                    for (var _c = (e_4 = void 0, __values(cartUpsellsQuery.data.products)), _d = _c.next(); !_d.done; _d = _c.next()) {
                        var product = _d.value;
                        var unavailableRegions = (0, regions_unavailable_1.getUnavailableRegions)(product.tags.split(', '));
                        if (tagAndCountryCodeRestrictProduct(unavailableRegions, userGeolocationQuery.data.countryCode))
                            continue;
                        try {
                            for (var _e = (e_5 = void 0, __values(product.variants)), _f = _e.next(); !_f.done; _f = _e.next()) {
                                var variant = _f.value;
                                if (variant.id === config.variantId && (variant.inventory_quantity || 0) > 0) {
                                    return { product: product, variant: variant, nameOverride: config.nameOverride };
                                }
                            }
                        }
                        catch (e_5_1) { e_5 = { error: e_5_1 }; }
                        finally {
                            try {
                                if (_f && !_f.done && (_b = _e.return)) _b.call(_e);
                            }
                            finally { if (e_5) throw e_5.error; }
                        }
                    }
                }
                catch (e_4_1) { e_4 = { error: e_4_1 }; }
                finally {
                    try {
                        if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
                    }
                    finally { if (e_4) throw e_4.error; }
                }
            })();
            if (variantGroup)
                variantGroups.push(variantGroup);
        };
        try {
            for (var upsellVariantConfigs_1 = __values(upsellVariantConfigs), upsellVariantConfigs_1_1 = upsellVariantConfigs_1.next(); !upsellVariantConfigs_1_1.done; upsellVariantConfigs_1_1 = upsellVariantConfigs_1.next()) {
                var config = upsellVariantConfigs_1_1.value;
                _loop_1(config);
            }
        }
        catch (e_3_1) { e_3 = { error: e_3_1 }; }
        finally {
            try {
                if (upsellVariantConfigs_1_1 && !upsellVariantConfigs_1_1.done && (_a = upsellVariantConfigs_1.return)) _a.call(upsellVariantConfigs_1);
            }
            finally { if (e_3) throw e_3.error; }
        }
        return variantGroups;
    }, [bundleConfig, cartUpsellsQuery.data, userGeolocationQuery.data, upsellVariantConfigs]);
    if (upsellVariantGroups.length < 1 || !bundleConfig)
        return null;
    var baseProperties = (function () {
        var _a;
        // If the bundle type is a-la-carte, we'll just be adding more a-la-carte items to the user's cart, so the properties should be an empty object.
        if (bundleConfig.bundleType === 'a-la-carte')
            return {};
        // If the bundle type is vitamins, we just want to add a-la-carte items to the user's cart, so the properties should be an empty object.
        if (bundleConfig.bundleType === 'vitamin-bundle')
            return {};
        // Otherwise, we must have a diaper or fundamentals bundle. Therefore we get base properties from the first child in the bundle so that when adding to
        // cart, we put the upsell item into this bundle.
        return (_a = bundleConfig.bundle.children) === null || _a === void 0 ? void 0 : _a[0].properties;
    })();
    var sliderSettings = {
        dots: false,
        arrows: false,
        centerMode: false,
        infinite: true,
        autoplay: true,
        slidesToScroll: 1,
        // react-slick seems to have a bug where it will just duplicate the 1 slide given if slidesToShow is 2 and the amount of slides we actually have is 1
        slidesToShow: upsellVariantGroups.length !== 1 ? 2 : 1,
        autoplaySpeed: 3000,
        speed: 500,
        pauseOnFocus: true,
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { className: 'padding-top-5 padding-bottom-10', style: { backgroundColor: '#F4F4F4' } },
            react_1.default.createElement("div", { className: 'padding-horizontal-4' },
                react_1.default.createElement("div", { className: 'font-bold padding-bottom-2', style: { fontSize: '14px' } }, title),
                react_1.default.createElement(react_slick_1.default, __assign({}, sliderSettings), upsellVariantGroups.map(function (group, i) {
                    return (react_1.default.createElement("div", { key: i + group.variant.id },
                        react_1.default.createElement(upsell_card_1.default, { baseProperties: baseProperties, product: group.product, variant: group.variant, nameOverride: group === null || group === void 0 ? void 0 : group.nameOverride, setAddingState: setIsAddingProduct })));
                }))))));
};
exports.default = UpsellsArea;
